// See http://jszen.blogspot.com/2007/03/how-to-build-simple-calendar-with.html for calendar logic.

import React from 'react';
import {Popover, OverlayTrigger, Button} from 'react-bootstrap';
import moment from 'moment';
moment.locale('cs');

const makeInputValueString = function (date) {
	const m = moment(date);
	return m.format('M/YYYY');
};

const CalendarHeader = React.createClass({
	displayName: "DatePickerHeader",
	propTypes: {
		displayDate: React.PropTypes.object.isRequired,
		onChange: React.PropTypes.func.isRequired,
		monthLabels: React.PropTypes.array.isRequired,
		onDateClick: React.PropTypes.func.isRequired,
		previousButtonElement: React.PropTypes.oneOfType([
			React.PropTypes.string,
			React.PropTypes.object
		]).isRequired,
		nextButtonElement: React.PropTypes.oneOfType([
			React.PropTypes.string,
			React.PropTypes.object
		]).isRequired,
	},
	handleClickPrevious(){
		const newDisplayDate = new Date(this.props.displayDate);
		newDisplayDate.setMonth(newDisplayDate.getMonth() - 1);
		this.props.onChange(newDisplayDate);
	},
	handleClickNext(){
		const newDisplayDate = new Date(this.props.displayDate);
		newDisplayDate.setMonth(newDisplayDate.getMonth() + 1);
		this.props.onChange(newDisplayDate);
	},
	render() {
		return <div className="text-center">
			<div className="text-muted pull-left" onClick={this.handleClickPrevious}
				 style={{cursor: "pointer"}}>{this.props.previousButtonElement}</div>
			<span
				onClick={this.props.onDateClick}>{this.props.monthLabels[this.props.displayDate.getMonth()]} {this.props.displayDate.getFullYear()}</span>
			<div className="text-muted pull-right" onClick={this.handleClickNext}
				 style={{cursor: "pointer"}}>{this.props.nextButtonElement}</div>
		</div>;
	}
});

const daysInMonth = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];

const Calendar = React.createClass({
	displayName: "DatePickerCalendar",
	propTypes: {
		selectedDate: React.PropTypes.object,
		displayDate: React.PropTypes.object.isRequired,
		onChange: React.PropTypes.func.isRequired,
		dayLabels: React.PropTypes.array.isRequired,
		cellPadding: React.PropTypes.string.isRequired,
		onUnmount: React.PropTypes.func.isRequired
	},
	componentWillUnmount(){
		this.props.onUnmount();
	},
	handleClick(day) {
		const newSelectedDate = new Date(this.props.displayDate);
		newSelectedDate.setDate(day);
		this.props.onChange(newSelectedDate);
	},
	render() {
		const currentDate = new Date();
		const currentDay = currentDate.getDate();
		const currentMonth = currentDate.getMonth();
		const currentYear = currentDate.getFullYear();
		const selectedDay = this.props.selectedDate ? this.props.selectedDate.getDate() : null;
		const selectedMonth = this.props.selectedDate ? this.props.selectedDate.getMonth() : null;
		const selectedYear = this.props.selectedDate ? this.props.selectedDate.getFullYear() : null;
		const year = this.props.displayDate.getFullYear();
		const month = this.props.displayDate.getMonth();
		const firstDay = new Date(year, month, 1);
		let startingDay = firstDay.getDay() - 1;
		if (startingDay == -1) {
			startingDay = 6;
		}
		let monthLength = daysInMonth[month];
		if (month == 1) {
			if ((year % 4 == 0 && year % 100 != 0) || year % 400 == 0) {
				monthLength = 29;
			}
		}
		const weeks = [];
		let day = 1;
		for (let i = 0; i < 9; i++) {
			let week = [];
			for (let j = 0; j <= 6; j++) {
				if (day <= monthLength && (i > 0 || j >= startingDay)) {
					const selected = day === selectedDay && month == selectedMonth && year === selectedYear;
					const current = day === currentDay && month == currentMonth && year === currentYear;
					week.push(<td key={j} onClick={this.handleClick.bind(this, day)}
								  style={{cursor: "pointer", padding: this.props.cellPadding}}
								  className={selected ? "bg-primary" : current ? "today" : null}>{day}</td>);
					day++;
				} else {
					week.push(<td key={j}/>);
				}
			}
			weeks.push(<tr key={i}>{week}</tr>);
			if (day > monthLength) {
				break;
			}
		}
		return <table className="text-center reactis-calendar">
			<thead>
			<tr className="day-labels">
				{this.props.dayLabels.map((label, index)=> {
					return <td key={index} style={{padding: this.props.cellPadding}}>
						<small>{label}</small>
					</td>
				})}
			</tr>
			</thead>
			<tbody>
			{weeks}
			</tbody>
		</table>;
	}
});

const DatePickerClass = React.createClass({
	displayName: "DatePicker",
	propTypes: {
		value: React.PropTypes.string,
		cellPadding: React.PropTypes.string,
		dayLabels: React.PropTypes.array,
		monthLabels: React.PropTypes.array,
		onChange: React.PropTypes.func,
		clearButtonElement: React.PropTypes.oneOfType([
			React.PropTypes.string,
			React.PropTypes.object
		]),
		previousButtonElement: React.PropTypes.oneOfType([
			React.PropTypes.string,
			React.PropTypes.object
		]),
		nextButtonElement: React.PropTypes.oneOfType([
			React.PropTypes.string,
			React.PropTypes.object
		]),
		placement: React.PropTypes.string
	},
	getDefaultProps() {
		return {
			cellPadding: "5px",
			dayLabels: ['Po', 'Út', 'St', 'Čt', 'Pá', 'So', 'Ne'],
			monthLabels: ['Leden', 'Únor', 'Březen', 'Duben',
				'Květen', 'Červen', 'Červenec', 'Srpen', 'Září',
				'Říjen', 'Listopad', 'Prosinec'],
			placeholder: "",
			clearButtonElement: "×",
			previousButtonElement: "<",
			nextButtonElement: ">",
			placement: "bottom"
		}
	},
	getInitialState() {
		var state = this.makeDateValues(this.props.value ? this.props.value : null);
		state.focused = false;
		return state;
	},
	makeDateValues(value) {

		let displayDate;
		let val;
		displayDate = new Date();
		displayDate.setHours(0);
		displayDate.setMinutes(0);
		displayDate.setSeconds(0);
		displayDate.setMilliseconds(0);

		let selectedDate = value ? new Date(value) : null;
		const isValid = value ? !isNaN(selectedDate.getTime()) : false;
		const isISO = isValid && (value == selectedDate.toISOString() ||
				value == moment(selectedDate).format("YYYY-MM-DD") ||
				value == moment(selectedDate).format("YYYY-MM-DD HH:mm:ss")
			);

		if (isValid) {
			if (isISO) {
				value = value ? makeInputValueString(selectedDate) : null;
			}
			displayDate = new Date(selectedDate);
			val = selectedDate ? selectedDate.toISOString() : null;
		}
		else {
			selectedDate = null;
		}

		return {
			value: val,
			displayDate: displayDate,
			selectedDate: selectedDate,
			inputValue: value
		}
	},
	clear() {
		this.setState(this.makeDateValues(null));
		if (this.props.onChange) {
			this.props.onChange(null);
		}
	},
	handleHide(e){
		/*if (document.activeElement === this.refs.input.getInputDOMNode()) {
			return;
		}*/
		this.setState({
			focused: false
		});
		if (this.props.onBlur) {
			this.props.onBlur(e);
		}
	},
	handleFocus(e){
		if (this.refs.overlay.state.isOverlayShown === true) {
			return;
		}
		this.setState({
			focused: true
		});
		if (this.props.onFocus) {
			this.props.onFocus(e);
		}
	},
	handleBlur(e){
		if (this.refs.overlay.state.isOverlayShown === true) {
			return;
		}
		this.setState({
			focused: false
		});
		if (this.props.onBlur) {
			this.props.onBlur(e);
		}
	},
	handleHeaderDateClick(e) {

	},
	getValue(){
		return this.state.selectedDate ? this.state.selectedDate.toISOString() : null;
	},
	handleInputChange(e){
		let inputValue = e.target.value;

		var dateReg = /^\d\d?\/\d{4}$/
		const validFormat = inputValue.match(dateReg);

		if (inputValue == '') {
			this.setState({
				inputValue: inputValue
			});
			if (this.props.onChange) {
				this.props.onChange(undefined);
			}
		}
		else {
			if (validFormat) {
				const selectedDate = moment(inputValue, 'M/YYYY');
				if (selectedDate.isValid()) {
					this.setState({
						inputValue: inputValue,
						selectedDate: selectedDate.toDate(),
						displayDate: selectedDate.toDate(),
						value: selectedDate.toISOString()
					});
					if (this.props.onChange) {
						this.props.onChange(selectedDate.toISOString());
					}
				}
				else {
					this.setState({
						inputValue: inputValue
					});
				}
			}
			else {
				this.setState({
					inputValue: inputValue
				});
				if (this.props.onChange) {
					this.props.onChange(inputValue);
				}
			}
		}
	},
	onChangeMonth(newDisplayDate) {
		this.setState({
			displayDate: newDisplayDate
		});
	},
	onChangeDate(newSelectedDate) {
		this.setState({
			inputValue: makeInputValueString(newSelectedDate),
			selectedDate: newSelectedDate,
			displayDate: newSelectedDate,
			value: newSelectedDate.toISOString()
		});
		this.refs.overlay.handleDelayedHide();
		if (this.props.onChange) {
			this.props.onChange(newSelectedDate.toISOString());
		}
	},
	componentWillReceiveProps(newProps) {
		const value = newProps.value ? newProps.value : null;
		if (this.getValue() !== value) {
			this.setState(this.makeDateValues(value));
		}
	},
	render() {
		const calendarHeader = <CalendarHeader
			previousButtonElement={this.props.previousButtonElement}
			nextButtonElement={this.props.nextButtonElement}
			displayDate={this.state.displayDate}
			onDateClick={this.handleHeaderDateClick}
			onChange={this.onChangeMonth}
			monthLabels={this.props.monthLabels}/>;
		const popOver = <Popover id="calendar" placement="top" title={calendarHeader}>
			<Calendar cellPadding={this.props.cellPadding} selectedDate={this.state.selectedDate}
					  displayDate={this.state.displayDate} onChange={this.onChangeDate} dayLabels={this.props.dayLabels}
					  onUnmount={this.handleHide}/>
		</Popover>;

		const props = {
			autoFocus: this.props.autoFocus,
			className: this.props.className,
			disabled: this.props.disabled,
			name: this.props.name,
			readOnly: this.props.readOnly,
			required: this.props.required,
			size: this.props.size,
			style: this.props.style,
			tabIndex: this.props.tabIndex,
			title: this.props.title,
		};

		return <div style={{display: 'inline-block', width:80}}>
				<OverlayTrigger ref="overlay" trigger="click" rootClose placement={this.props.placement}
								overlay={popOver} delayHide={100}>
					<input
						{...props}
						className="form-control"
						label={null}
						value={this.state.inputValue}
						ref="input"
						type="text"
						placeholder={this.props.placeholder}
						onFocus={this.handleFocus}
						onBlur={this.handleBlur}
						onChange={this.handleInputChange}
					/>
				</OverlayTrigger>
				<input type="hidden" id={this.props.id} name={this.props.name} value={this.state.value}/>
			</div>;
	}
});

export default DatePickerClass;


// WEBPACK FOOTER //
// ./src/reactis/reactis-monthpicker/src/DatePicker.js